/**
 * created by yxy
 *
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Transfer, Tree, Steps, Tabs, Icon, Button,Modal,Card} from 'antd';
import {User} from '../components/User';
import {uuid} from "../../../utils";
import {message} from './Mess'
import CmForm from "../../../components/CmForm/CmForm";
const { Step } = Steps;
const { TabPane } = Tabs;


export default class HoldAll extends Component {
    static defaultProps = {

        stepArray:['第一步','第二步','第三步'],
        tableData:['部门设置','用户设置'],
        showProcess:false,
        footer:'',
        bool:false,
        onChange:()=>{

        },
        shareSure:()=>{

        }
    };
    static propTypes = {
        title:PropTypes.string,//弹出框标题
        onChange:PropTypes.func,// 方法
        stepArray:PropTypes.array.isRequired, // 步骤条显示的文字
        tableData:PropTypes.array, // tab数据
        showProcess:PropTypes.bool.isRequired,// 是否显示进度条
        footer:PropTypes.string.isRequired,// 是否显示底部的确定按钮
        shareSure:PropTypes.func,// 方法
    };

    constructor(props) {

        console.log("constructor:     ");

        super(props);
        this.state = {
            share:false,
            targetKeys:[],
            user:[],

        }
    }
    componentWillMount() {
    }

    componentDidMount() {
    }

    modalKey = uuid();

    show(refreshKey){
        if(refreshKey){
            this.modalKey = uuid();
        }
        this.setState({
            share:true,
            current:'0'
        })
    }
    render() {


        return (
            <Modal
                maskClosable={false}
                keyboard={true}
                title='分享'
                centered
                key={this.modalKey}
                width={'800px'}
                visible={this.state.share}
                onCancel={this.handleCancel}
            >
                <CmForm onSubmit={() => {

                }}>
                <div>
                        <div style={{height:'500px',margin:'0 auto'}}>
                              <User updata={false} callbackUserData={(data)=>{
                                     this.setState({user:data})
                                     this.state.user = data;
                                    }}/>
                        </div>
                </div>
                </CmForm>
            </Modal>
        )
    }
    saveCallback=()=>{
        this.props.onSaveCallback&&this.props.onSaveCallback(this.state.user);
        if(this.state.user.length){
            this.setState({share: false});
        }else{
            message.info('请至少选择一个要分享的用户')
        }
        this.state.user = [];
        this.setState({})
    };
    handleCancel = e => {
        this.setState({share: false});
    };


}